module.exports = __webpack_public_path__ + "img/logo.33e39d89.png";